"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalGeneric = function ModalGeneric(_ref) {
  var show = _ref.show,
      onHide = _ref.onHide,
      centered = _ref.centered,
      title = _ref.title,
      size = _ref.size,
      infoModal = _ref.infoModal,
      children = _ref.children,
      primaryActionDisabled = _ref.primaryActionDisabled,
      primaryActionLabel = _ref.primaryActionLabel,
      primaryActionVariant = _ref.primaryActionVariant,
      primaryAction = _ref.primaryAction,
      secondaryActionDisabled = _ref.secondaryActionDisabled,
      secondaryActionLabel = _ref.secondaryActionLabel,
      secondaryActionVariant = _ref.secondaryActionVariant,
      secondaryAction = _ref.secondaryAction,
      animation = _ref.animation,
      backdrop = _ref.backdrop,
      scapeGetOut = _ref.scapeGetOut,
      variantHeader = _ref.variantHeader;
  var hasPrimaryAction = primaryActionLabel && primaryAction;
  var hasSecondaryAction = secondaryActionLabel && secondaryAction;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
    className: "modal-generic ".concat(infoModal ? 'info-modal' : 'general-modal', " ").concat(variantHeader),
    show: show,
    centered: centered,
    onHide: onHide,
    size: size,
    animation: animation,
    backdrop: backdrop,
    keyboard: scapeGetOut
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    closeButton: !!infoModal
  }, /*#__PURE__*/_react.default.createElement("p", null, title)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, null, children, (hasPrimaryAction || hasSecondaryAction) && /*#__PURE__*/_react.default.createElement("div", {
    className: "actions-container"
  }, hasSecondaryAction && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    onClick: secondaryAction,
    label: secondaryActionLabel || ' ',
    variant: secondaryActionVariant || 'outline-primary',
    disabled: secondaryActionDisabled
  }), hasPrimaryAction && /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "button",
    onClick: primaryAction,
    label: primaryActionLabel || ' ',
    variant: primaryActionVariant || 'primary',
    disabled: primaryActionDisabled
  }))));
};

ModalGeneric.propTypes = {
  show: _propTypes.default.bool,
  centered: _propTypes.default.bool,
  onHide: _propTypes.default.func,
  title: _propTypes.default.string,
  size: _propTypes.default.oneOf(['sm', 'md', 'lg', 'xl']),
  infoModal: _propTypes.default.bool,
  children: _propTypes.default.element,
  primaryActionDisabled: _propTypes.default.bool,
  primaryActionVariant: _propTypes.default.string,
  primaryActionLabel: _propTypes.default.string,
  primaryAction: _propTypes.default.func,
  secondaryActionDisabled: _propTypes.default.bool,
  secondaryActionLabel: _propTypes.default.string,
  secondaryActionVariant: _propTypes.default.string,
  secondaryAction: _propTypes.default.func,
  backdrop: _propTypes.default.oneOf(['static', true, false]),
  scapeGetOut: _propTypes.default.bool,
  variantHeader: _propTypes.default.oneOf(['warning', 'danger', 'light', 'success'])
};
ModalGeneric.defaultProps = {
  show: false,
  centered: true,
  onHide: null,
  title: '',
  size: 'md',
  infoModal: false,
  children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null),
  primaryActionDisabled: false,
  primaryActionLabel: '',
  primaryActionVariant: 'primary',
  primaryAction: null,
  secondaryActionDisabled: false,
  secondaryActionLabel: '',
  secondaryActionVariant: 'outline-primary',
  secondaryAction: null,
  backdrop: false,
  scapeGetOut: false,
  variantHeader: 'light'
};
var _default = ModalGeneric;
exports.default = _default;